<app-header></app-header>

<ion-content [fullscreen]="true" [scrollEvents]="true" (ionScroll)="onPaymentListScroll($event)">
  <ion-grid [fixed]="true" class="steps-grid">
    @for (chunk of chunkedSteps(); track $index) {
    <ion-row>
      @for (step of chunk; track $index) {
      <ion-col size="3">
        <div class="wizard-step">
          <div class="wizard-step-header">
            <app-custom-radio [status]="step.status"></app-custom-radio>
            <div class="wizard-step-line"></div>
          </div>
          <div class="wizard-step-description ion-hide-md-down">
            <ion-text color="primary">
              <h3>{{ step.name | localized}}</h3>
            </ion-text>
            <ion-text color="medium">
              <h4 class="wizard-step-description__secondary-text">{{ step.description | localized }}</h4>
            </ion-text>
          </div>
        </div>
      </ion-col>
      }
    </ion-row>
    }
  </ion-grid>

  <ion-grid [fixed]="true" class="description-wrapper">
    <ion-row>
      <ion-col> <h3>{{ currentStep()?.name | localized }}</h3> </ion-col>
    </ion-row>
    @if(currentStep()?.explanation) {
    <ion-row>
      <ion-col size="12">
        <ion-text color="medium">
          <h4>{{ currentStep()?.explanation | localized }}</h4>
        </ion-text>
      </ion-col>
    </ion-row>
    }
  </ion-grid>

  @if(currentStepStage() == stages.VariationSelection) {
  <app-variation-selection
    [(selectedVariation)]="selectedVariation"
    [printVariations]="printVariations()"
    (selectedVariationChange)="onVariationChange($event)"
    (doNextStep)="onNextClick()"></app-variation-selection>
  } @if(currentStepStage() == stages.PaperSizeSelection) {
  <app-paper-size-selection
    [paperSizes]="paperSizes()"
    [(selectedPaperSize)]="selectedPaperSize"
    (selectedPaperSizeChange)="onPaperSizeChange($event)"
    (doNextStep)="onNextClick()"></app-paper-size-selection>
  } @if(currentStepStage() == stages.PaperTypeSelection) {
  <app-paper-type-selection
    [paperTypes]="paperTypes()"
    [(selectedPaperType)]="selectedPaperType"
    (selectedPaperTypeChange)="onPaperTypeChange($event)"
    (doNextStep)="onNextClick()"></app-paper-type-selection>
  } @if(currentStepStage() == stages.PrintStyleSelection) {
  <app-print-style-selection
    [selectedVariation]="selectedVariation()"
    [selectedPaperSize]="selectedPaperSize()"
    [selectedPaperType]="selectedPaperType()"
    [(selectedPaperSideType)]="selectedPaperSideType"
    [(selectedPaperColorType)]="selectedPaperColorType"
    (selectedPaperSideTypeChange)="onPaperSideTypeChange($event)"
    (selectedPaperColorTypeChange)="onPaperColorTypeChange($event)"
    (doNextStep)="onNextClick()">
  </app-print-style-selection>
  } @if(currentStepStage() == stages.ExtrasSelection) {
  <app-extras-selection
    [paperExtras]="paperExtras()"
    [(selectedPaperExtras)]="selectedExtras"
    (selectedPaperExtrasChange)="onExtrasChange($event)"
    (doNextStep)="onNextClick()"></app-extras-selection>
  } @if(currentStepStage() == stages.PrintOfficeSelection) {
  <app-print-office-selection
    [allPrintOffices]="printOffices()"
    [selectedVariation]="selectedVariation()"
    [selectedPaperSize]="selectedPaperSize()"
    [selectedPaperType]="selectedPaperType()"
    [selectedPaperSideType]="selectedPaperSideType()"
    [selectedPaperColorType]="selectedPaperColorType()"
    [selectedExtras]="selectedExtras()"
    [uploadedFiles]="uploadedFiles()"
    [(selectedOffice)]="selectedOffice"
    (selectedOfficeChange)="onSelectedOfficeChange($event)"
    (doNextStep)="onNextClick()"
    (doBackStep)="onBackClick()"></app-print-office-selection>
  } @if(currentStepStage() == stages.Payment) {
  <app-payment-selection
    [selectedVariation]="selectedVariation()"
    [selectedPaperSize]="selectedPaperSize()"
    [selectedPaperType]="selectedPaperType()"
    [selectedPaperSideType]="selectedPaperSideType()"
    [selectedPaperColorType]="selectedPaperColorType()"
    [selectedExtras]="selectedExtras()"
    [uploadedFiles]="uploadedFiles()"
    [selectedOffice]="selectedOffice()"></app-payment-selection>
  }

  <app-files-selection
    #filesSelectionComponent
    [selectedVariation]="selectedVariation()"
    [selectedPaperSideType]="selectedPaperSideType()"
    [class.ion-hide]="currentStepStage() != stages.FilesSelection"></app-files-selection>
</ion-content>

<ion-footer class="stepper-footer" mode="md">
  <ion-toolbar>
    <ion-buttons slot="start">
      <button
        mode="md"
        [class.invisible]="currentStep()?.isBackButtonHidden"
        class="wizard-button"
        expand="full"
        color="lightblue"
        (click)="onBackClick()">
        <ion-icon color="primary60" name="arrow-back-outline"></ion-icon>
      </button>
    </ion-buttons>

    <div class="step-indicator">{{ currentStep()?.name | localized }}</div>

    <ion-buttons slot="end">
      <button
        mode="md"
        [class.disabled]="!hasCurrentStepSelection()"
        [class.invisible]="currentStep()?.isNextButtonHidden"
        [disabled]="!hasCurrentStepSelection()"
        expand="full"
        color="lightblue"
        (click)="onNextClick()"
        class="wizard-button margin-left-auto">
        <ion-icon color="primary60" name="arrow-forward-outline"></ion-icon>
      </button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

@if(currentStepStage() == stages.Payment) {
<div class="scroll-indicator-wrapper">
  <div class="scroll-indicator" *ngIf="showScrollIndicator">
    <div class="scroll-text">{{ "HOME.SCROLL_DOWN" | translate }}</div>
  </div>
</div>
}
